import { type AxiosResponse } from 'axios'
import { type AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import {
  type IParamsDeleteUsersPush,
  type IParamsUpdateUsersPush,
  type IResponseUpdateUsersPush,
} from './types'

class Api {
  updateUsersPush(
    data: IParamsUpdateUsersPush,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseUpdateUsersPush>> {
    return baseApi.post('users/push', data, options)
  }

  deleteUsersPush(
    params: IParamsDeleteUsersPush,
    options?: AxiosOptions
  ): Promise<AxiosResponse<unknown>> {
    return baseApi.delete('users/push', {
      ...options,
      params,
    })
  }
}

export const NotificationsApi = new Api()
